import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbComponentModule } from './../_component/breadcrumb/breadcrumb.module';
import { ChangePasswordComponentModule } from './change-password/change-password.module';

import { IonicModule } from '@ionic/angular';

import { SettingsPageRoutingModule } from './settings-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from 'src/app/_component/inputs/inputs.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';
import { HeaderModule } from '../../_component/header/header.module';
import { SelectDropdownModule } from '../_component/select-dropdown/select-dropdown.module';
import { UploadAttachmentModule } from '../_component/upload-attachment/upload-attachment.module';
import { SettingsPage } from './settings.page';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    SettingsPageRoutingModule,
    TranslateModule,
    HeaderModule,
    SelectDropdownModule,
    UploadAttachmentModule,
    ChangePasswordComponentModule,
    BreadcrumbComponentModule,
    InputsModule,
    SharedDirectivesModule,
  ],
  declarations: [SettingsPage],
})
export class SettingsPageModule {}
